module.exports = __webpack_public_path__ + "img/9.59e95df8.png";